import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { StoreService } from '@app/services/store.service';
import { Subscription } from 'rxjs';
import { AnalyticsService } from '@app/services/analytics.service';

@Component({
    selector: 'tf-product-type-selector',
    templateUrl: './product-type-selector.component.html',
    styleUrls: ['./product-type-selector.component.scss']
})
export class ProductTypeSelectorComponent implements OnInit, OnDestroy {

    @Input()
    selectedTab: 'assays' | 'arrays' = 'assays';

    @Input()
    keyword: string = '*';

    @Input()
    keywordUsed: string = '';

    assayCount: number;
    arrayCount: number;
    countsSubscription: Subscription;

    isFisherSci: boolean = false;

    constructor(
        private router: Router,
        private sanitizer: DomSanitizer,
        private storeService: StoreService,
        private productSiteRegionService: ProductSiteRegionService,
        private analyticsService: AnalyticsService
    ) {

    }

    ngOnInit(): void {

        this.isFisherSci = this.productSiteRegionService.isFisherSci();

        this.countsSubscription = this.storeService.searchResultCountsState$.subscribe(state => {
            this.assayCount = state.assayCount;
            this.arrayCount = state.arrayCount;
        });


        const searchResultsSubscription = this.storeService.searchResults$.subscribe((searchResults) => {
            if (searchResults === null) {
                return;
            } else {
                this.keywordUsed = searchResults?.keywordUsed;
            }
        });

        this.countsSubscription.add(searchResultsSubscription);
    }

    ngOnDestroy() {
        this.countsSubscription.unsubscribe();
    }

    onClickTabHandler(tab: string) {

        const key = this.keywordUsed && this.keywordUsed.length > 0 ? this.keywordUsed : this.keyword;

        if (tab === 'assays') {

            void this.router.navigate(['gene-expression/assay/query'], {
                queryParams: {
                    keyword: key,
                    productType: 'ge',
                    productSubType: 'ge'
                }
            });

            this.analyticsService.triggerAnalyticsOnLoad('taqman search results:gene expression assays');

        } else {

            void this.router.navigate(['gene-expression/array/query'], {
                queryParams: {
                    keyword: key,
                    productType: 'gx',
                    productSubType: 'gx'
                }
            });
            
            this.analyticsService.triggerAnalyticsOnLoad('taqman search results:gene expression arrays');

        }
    }

    isSelected(tab: string): boolean {
        return this.selectedTab === tab;
    }

    getTabClasses(tab: string): string[] {

        if (this.selectedTab === tab) {
            return ['selected'];
        }

        return [];

    }

}
